<template>
  <div>
  <v-card flat>
    <v-btn class="gray mb-n2 ml-2 mt-n1" text @click="$emit('back-to-list')">
      <v-icon>$sl-arrow-left</v-icon>Tillbaka</v-btn
    >
    <v-card-title>
      <h5>{{ apprentice | fullName }}</h5>
    </v-card-title>

    <v-card-text v-if="unlinkApprenticenship">
      <p class="mt-n9 mb-7">{{ apprentice.personalNumber | formatPnr }}</p>
      <p class="semi-bold mb-2">Klicka på knappen nedan för att koppla bort lärlingen och välja bortkopplingsdatum</p>
      <v-btn color="secondary" @click="deleteApprenticenship" :disabled="Boolean(apprenticeship.manuallyEndedDate) || !canDelete"
        ><v-icon>$sl-unlink</v-icon>KOPPLA BORT {{ apprentice | fullName }} FRÅN {{ selectedCompany.name }}</v-btn
      >
    </v-card-text>

    <v-card-actions class="mt-n4" v-if="!unlinkApprenticenship">
      <v-btn color="secondary" @click="personClick(apprentice)">
        <v-icon>$sl-user2</v-icon>
        Visa personprofil
      </v-btn>
    </v-card-actions>
    <v-card-text v-if="!unlinkApprenticenship">
      <v-row>
        <v-col sm="12" md="6"
          ><h6>ADRESS</h6>
          <p class="body-1">
            {{ apprentice.address1 || '' }}
            <br />
            {{ apprentice.zip | formatZip }} {{ apprentice.city || '' }}
          </p>
        </v-col>
        <v-col sm="12" md="6"
          ><h6>KONTAKTINFORMATION</h6>
          <v-row class="mt-n5">
            <v-col cols="5">
              <p class="semi-bold text-uppercase">mobiltelefon</p>
            </v-col>
            <v-col cols="7">
              <p class="body-1 mt-n1">{{ apprentice.mobilephone || '' }}</p>
            </v-col>
          </v-row>
          <v-row class="mt-n8">
            <v-col cols="5">
              <p class="semi-bold text-uppercase">e-postadress</p>
            </v-col>
            <v-col cols="7">
              <p class="mt-n1 body-1">
                <a v-if="apprentice.email" :href="'mailto:' + apprentice.email">{{ apprentice.email || '' }}</a>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h6 class="mt-n2">MINA SIDOR</h6>

      <v-row class="mt-4">
        <v-col sm="2" md="2">
          <p class="semi-bold text-uppercase">Arbetsplatser</p>
        </v-col>
        <v-col sm="10" md="5">
          <div class="body-1 mt-4">
            <div v-for="(w, index) in workplaces" :key="index">
              <p class="mt-n4">
                {{ w.workplaceaddress.name }}
                <span v-if="getDepartmentsString(w.workplaceaddress.departmentWorkplaces)"
                  >({{ getDepartmentsString(w.workplaceaddress.departmentWorkplaces) }})</span
                >
              </p>
            </div>
          </div>
        </v-col>
        <v-col sm="0" md="5"></v-col>
      </v-row>

      <v-row class="mt-n4">
        <v-col sm="2" md="2">
          <p class="semi-bold text-uppercase">HANDLEDARE</p>
        </v-col>
        <v-col sm="10" md="5">
          <div class="body-1 mt-4">
            <div v-for="(h, index) in apprenticeshipInstructors" :key="index">
              <p class="mt-n4" v-if="h && h.instructor && h.instructor.employed">
                <router-link :to="'/people/' + h.instructor.employed.id"
                  >{{ h.instructor.employed | fullName }}
                </router-link>
              </p>
            </div>
          </div>
        </v-col>
        <v-col sm="0" md="5"></v-col>
      </v-row>
    </v-card-text>
    </v-card>
    <DisconnectApprenticeModal 
      @back-to-list="$emit('back-to-list', true)" 
      :show="show" 
      @close="show = false" 
      :apprenticeshipId="apprenticeshipId" 
    />
  </div>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import get from 'lodash/get'
import DisconnectApprenticeModal from '@/components/person/DisconnectApprenticeModal.vue'
import {CanIDo} from '@/components/mixins'
export default {
  components: { DisconnectApprenticeModal },
  mixins:[CanIDo],
  props: {
    apprenticeshipId: {
      type: Number,
      default: 0
    },
    unlinkApprenticenship: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      workplaces: [],
      apprenticeshipInstructors: [],
      apprenticeship: {},
      apprentice: {},
      show: false,
    }
  },
  created() {
    this.getApprenticeship()
  },
  computed: {
    ...mapGetters('company', ['selectedCompany'])
  },

  asyncComputed: {
    canDelete(){
      return this.canIDo('apprentice', 'delete');
    },
  },

  methods: {
    personClick(apprentice) {
      this.$nextTick(() => this.$router.push({name: 'PersonDetail', params: {id: apprentice.id}}).catch(() => {}))
    },

    getApprenticeship() {
      API.getApprenticeship(this.apprenticeshipId)
        .then(response => {
          this.apprenticeshipInstructors = response.data.apprenticeshipInstructors
          this.apprentice = response.data.apprentice
          this.workplaces = response.data.workplaces
          this.apprenticeship = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDepartmentsString(departments) {
      return departments
        .map(d => {
          return get(d, 'department.name', '')
        })
        .join(', ')
    },
    async deleteApprenticenship() {
      this.show = true
      // const res = await this.$dialog.confirm({
      //   text: 'Bortkoppling går inte att ångra.',
      //   title: 'Är du säker på att du vill koppla bort denna person? ',
      //   actions: [
      //     {text: 'AVBRYT', key: false, icon: '$sl-cancel'},
      //     {text: 'KOPPLA BORT', key: true, icon: '$sl-unlink', outlined: true}
      //   ]
      // })

      if (res !== true) return
      API.endApprenticeship(this.apprenticeshipId, {data: {endDate: new Date()}})
        .then(response => {
          this.$events.fire('showInfo', 'Personen bortkopplad.')
          this.$emit('back-to-list', true)
        })
        .catch(error => {
          console.log(error)
          this.$events.fire('showError', 'Lärlingen är redan bortkopplad.')
        })
      // const res = show

      // if (res !== true) return
      // API.endApprenticeship(this.apprenticeshipId, {data: {endDate: new Date()}})
      //   .then(response => {
      //     this.$events.fire('showInfo', 'Personen bortkopplad.')
      //     this.$emit('back-to-list', true)
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>